import {
  anInsight,
  anInsightPage,
  mockInsightsDataGridQuery,
} from '__generated__';
import { HttpResponse } from 'msw';

import { mockInsights } from './InsightsListQueryOperation.mocks';

export const mockInsightsDataGridQuery_federated = {
  __typename: 'Query',
  insights: anInsightPage({
    hasNextPage: false,
    total: 2,
    objects: [
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight({
        ...mockInsights[0],
        tenant: 'federated-tenant-1',
        tenantUrl: 'https://federated-tenant-1.sumologic.com/sec',
        tenantName: 'Federated Tenant 1',
        deployment: 'stag',
      }),
      // @ts-expect-error assignee fails type checking here because it can be multiple different types
      anInsight({
        ...mockInsights[1],
        tenant: 'federated-tenant-2',
        tenantUrl: 'https://federated-tenant-2.sumologic.com/sec',
        tenantName: 'Federated Tenant 2',
        deployment: 'stag',
      }),
    ],
  }),
};

export const handlers = [
  mockInsightsDataGridQuery(
    async ({ query: _query, variables: _variables }) => {
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insights: anInsightPage({
            hasNextPage: false,
            total: 4,
            objects: [
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[0],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[1],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[2],
              }),
              // @ts-expect-error assignee fails type checking here because it can be multiple different types
              anInsight({
                ...mockInsights[3],
              }),
            ],
          }),
        },
      });
    }
  ),
];
